import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell title="Reset Password">
            {sent ? (
                <div className="text-center">
                    <p className="text-muted-foreground">If an account exists for <strong>{email}</strong>, we've sent a password reset link. Please check your inbox.</p>
                    <Link to="/login" className="inline-block mt-6 text-gold hover:underline">Back to Login</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-4">
                    <p className="text-sm text-muted-foreground text-center">Enter your email and we'll send you a reset link.</p>
                    <input data-testid="forgot-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                    <button data-testid="forgot-submit" disabled={loading} className="w-full bg-ink text-cream py-3 text-sm uppercase tracking-[0.15em] hover:bg-gold transition-colors disabled:opacity-50">{loading ? "Sending…" : "Send Reset Link"}</button>
                    <p className="text-center text-sm"><Link to="/login" className="text-gold hover:underline">Back to Login</Link></p>
                </form>
            )}
        </AuthShell>
    );
}
